import { ModuleWithProviders, NgModule } from '@angular/core';
import { LocalizeService } from './localize.service';

@NgModule()
export class LocalizeModule {
  static forRoot(): ModuleWithProviders<LocalizeModule> {
    return {
      ngModule: LocalizeModule,
    };
  }

  // Initialize the service
  constructor(private service: LocalizeService) {}
}
